import { SearchResultsProps } from "@omni/types/components/props/searchResults.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { withBreakpoints } from "@/utils/breakpoints/breakpoints.provider";

import { SearchResultsContextProvider } from "./context/searchResults.context";

type BaseComponentProps = RequireChildrenFor<SearchResultsProps>;

const BaseComponent = ({
    algoliaSearchParameters,
    productTileConfig,
    showFacets = true,
    children
}: BaseComponentProps) => {
    return (
        <SearchResultsContextProvider
            algoliaSearchParameters={algoliaSearchParameters}
            productTileConfig={productTileConfig}
            showFacets={showFacets}
        >
            {children}
        </SearchResultsContextProvider>
    );
};

export const Base = withBreakpoints(BaseComponent);
